document.addEventListener( 'DOMContentLoaded', function() {
  const buttons = document.querySelectorAll( '.e-btn--js-popup' );
  if ( !buttons.length ) return;
  
  buttons.forEach( function ( button ) {
    button.querySelector( 'a' ).addEventListener( 'click', function( event ) {
      event.preventDefault();
      const popupId =event.currentTarget.hash;
      const popup = document.querySelector( popupId );
      if ( !popup ) return;

      popup.classList.add( 'is-open' );
    } );
  } );
} );
